import { gql, mutate, watchQuery } from '@/services/apollo'

const GET_BRIDGES = gql`
  query BridgePage($input: BridgePageInput!) {
    bridgePage(input: $input) {
      bridge {
        id
        name
      }
      totalCount
    }
  }
`

const CREATE_BRIDGE = gql`
  mutation CreateBridge($input: CreateBridgeInput!) {
    createBridge(input: $input) {
      id
      name
    }
  }
`

const GET_BRIDGE = gql`
  query GetBridge($input: BridgeQueryInput!) {
    bridge(input: $input) {
      id
      name
      routerUrl
      properties {
        key
        value
      }
    }
  }
`

const EDIT_BRIDGE = gql`
  mutation EditBridge($input: EditBridgeInput!) {
    editBridge(input: $input) {
      id
      name
      routerUrl
      properties {
        key
        value
      }
    }
  }
`

const DELETE_BRIDGE = gql`
  mutation DeleteBridge($input: DeleteBridgeInput!) {
    deleteBridge(input: $input)
  }
`

export default {
  getBridges () {
    return watchQuery({ query: GET_BRIDGES, variables: { input: { limit: 0, offset: 0 } } })
  },
  getBridge (variables) {
    return watchQuery({ query: GET_BRIDGE, variables })
  },
  editBridge (input) {
    return mutate({ mutation: EDIT_BRIDGE, variables: { input} })
  },
  createBridge (input) {
    return mutate({ mutation: CREATE_BRIDGE, variables: { input } })
  },
  deleteBridge (input) {
    return mutate({ mutation: DELETE_BRIDGE, variables: { input } })
  }
}
